@if (this.realHospitalDetails) {

<mat-card class="profile-card px-15 pb-20">
    <mat-card-header>
        <mat-card-title>
            <div class="g-just-flex gap-15">
                <div class="round-icon-wrapper contrast">
                    <mat-icon>
                        {{detailsBuilderObject.resourceIcon}}
                    </mat-icon>
                </div>
                <span> {{detailsBuilderObject.resourceName | titlecase}}</span>
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="my-10">
            <mat-divider></mat-divider>
            <div class="my-20"></div>

            <div class="g-just-flex special-header-wrapper  my-20 mb-20 gap-18"
                style="justify-content: space-between; flex-wrap: wrap;">
                @if(detailsBuilderObject.specialHeader ){
                @let specialHeader = detailsBuilderObject.specialHeader;

                <app-special-header [resourceObject]="realHospitalDetails"
                    [specialHeader]="specialHeader"></app-special-header>
                }
                <div class="action-button mb-15 gap-15">
                    @if (realHospitalDetails) {
                        <button 
                            mat-raised-button 
                            color="primary"
                            (click)="onEditOrganization()">
                            <mat-icon>edit</mat-icon>
                            Edit Organization
                        </button>
                    }
                </div>
            </div>

            <div class="cards-wrapper">
                @for(group of detailsBuilderObject.groups; track $index;){
                    @if(group.groupMembers?.length > 0){
                        <mat-card>
                            <mat-card-header>
                                <div class="g-just-flex gap-15" style="align-items: flex-start; justify-content: flex-start;">
                                    <div class="header-words">
                                        <div class="title-flex g-just-flex gap-8"
                                            style="align-items: flex-start; justify-content: flex-start;">
                                            <mat-icon>{{group.groupIcon}}</mat-icon>
                                            <mat-card-title>{{group.groupName | titlecase}}</mat-card-title>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                @if(group.groupName === 'Details' || group.groupName === 'Addresses'){
                                    <!-- Custom rendering for Details and Addresses groups -->
                                    <div class="details-group">
                                        @for(member of group.groupMembers; track $index){
                                            <div class="detail-item">
                                                <span class="detail-label">{{member.label | titlecase}}:</span>
                                                @if(member.keyDataType === 'badge' && member.badgeActive){
                                                    <!-- Render badge for parent organization -->
                                                    <mat-chip-set aria-label="Organization badge">
                                                        <mat-chip selected>
                                                            <mat-icon matChipAvatar>workspaces</mat-icon>
                                                            {{member.staticValue}}
                                                        </mat-chip>
                                                    </mat-chip-set>
                                                } @else if(member.staticValue !== undefined && !member.isNestedExtension){
                                                    <!-- Display static values (like description) -->
                                                    <span class="detail-value">{{member.staticValue}}</span>
                                                } @else if(member.isNestedExtension && member.staticValue){
                                                    <!-- Render nested extension data -->
                                                    <div class="nested-extension-container">
                                                        @for(item of member.staticValue | keyvalue; track $index){
                                                            <div class="nested-item">
<span class="nested-label">{{ $any(item.key) | titlecase }}:</span>
                                                                <span class="nested-value">{{item.value}}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                } @else {
                                                    <!-- Use app-details-cardz for dynamic values -->
                                                    <app-details-cardz 
                                                        [group]="{groupMembers: [member]}" 
                                                        [resources]="realHospitalDetails">
                                                    </app-details-cardz>
                                                }
                                            </div>
                                        }
                                    </div>
                                } @else {
                                    <!-- Default rendering for other groups -->
                                    <div class="group-content">
                                        @if(group.groupMembers[0]?.isNestedExtension){
                                            <!-- Nested extensions - show as cards -->
                                            @for(member of group.groupMembers; track $index){
                                                @if(member.staticValue){
                                                    <div class="nested-extension-card">
                                                        <div class="extension-header">
                                                            <h4>{{member.label}}</h4>
                                                        </div>
                                                        <div class="nested-extension-container">
                                                            @for(item of member.staticValue | keyvalue; track $index){
                                                                <div class="nested-item">
                                                                <span class="nested-label">{{ $any(item.key) | titlecase }}:</span>    
@if(item.key === 'website' || (item.value && item.value.toString().startsWith('http'))) {
                                                                          
  <a [href]="item.value" target="_blank" class="nested-value-link">
                                                                            {{item.value}}
                                                                            <mat-icon>open_in_new</mat-icon>
                                                                        </a>
                                                                    } @else {
                                                                        <span class="nested-value">{{item.value}}</span>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            }
                                        } @else {
                                            <!-- Regular group members -->
                                            <app-details-cardz [group]="group" [resources]="realHospitalDetails"></app-details-cardz>
                                        }
                                    </div>
                                }
                            </mat-card-content>
                        </mat-card>
                    }
                }
            </div>
        </div>
    </mat-card-content>
</mat-card>

}

